<template>
  <div class="image-collection container-fluid">
    <div class="row">
        <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="image-box" id="trade-box">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">Trade Evaluation</div>
                        <div class="text bottom-text">Get the value of your trade online&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></div>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="image-box" id="finance-box">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">Finance Application</div>
                        <div class="text bottom-text">Apply for financing online and start your car buying process today&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></div>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12 pull-right">
            <div class="image-box" id="used-box" :style="{backgroundImage: usedBox}">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">Pre-Owned Specials</div>
                        <div class="text bottom-text">View our specials on pre-owned vehicles&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></div>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-8 col-sm-6 col-xs-12 pull-left">
            <div class="image-box" id="new-box" :style="{backgroundImage: newBox}">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">New Vehicle Specials</div>
                        <div class="text bottom-text">View our specials on our new vehicle inventory&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="image-box" id="service-box">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">Service</div>
                        <div class="text bottom-text">Schedule a service appointment with us online&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="image-box" id="parts-box">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">Parts</div>
                        <div class="text bottom-text no-wrap">Order genuine OEM parts online&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></div>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12">
            <div class="image-box" id="about-box" :style="{backgroundImage: aboutBox}">
                <a class="text-link" href="#">
                    <div class="image-overlay">
                        <div class="text top-text">About Us</div>
                        <div class="text bottom-text">Learn more about Auto Dealer&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></div>
                    </div>
                </a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      newBox: 'url(' + this.images.lifestyleImages.sedanImage + ')',
      usedBox: 'url(' + this.images.lifestyleImages.suvImage + ')',
      aboutBox: 'url(' + this.images.lifestyleImages.defaultImage + ')'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .image-collection {
      background: #fff;
      color: #fff;
  }
  .image-collection .col-xs-12 {
      padding: 0;
  }
  .image-collection .image-box {
      position: relative;
      width: 100%;
      background-size: cover;
  }
  .image-collection .image-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .5);
      overflow: hidden;
      width: 100%;
      height: 20%;
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      -o-transition: all 0.5s ease;
      transition: all .5s ease;
  }
  .image-collection .image-box:hover .image-overlay {
      height: 100%;
  }
  .image-collection .bottom-text {
      display: none;
      font-size: 16px;
  }
  .image-collection .image-box:hover .bottom-text {
      display: block;
      top: 70%;
  }
  .image-collection .top-text {
      font-size: 20px;
  }
  .image-collection .text {
      color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      text-align: center;
  }
  .image-collection .text-link,
  .image-collection .text-link i {
      color: #fff !important;
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      -o-transition: all 0.5s ease;
      transition: all .5s ease;
  }
  .image-collection .text-link i {
    font-size: 18px;
    line-height: 14px;
  }
  .image-collection .text-link:hover {
      text-decoration: none;
  }
  .image-collection .text-link:hover i {
      -webkit-transform: translateX(5px);
      -ms-transform: translateX(5px);
      transform: translateX(5px);
  }
  .image-collection #trade-box {
      background-image: url(../../static/images/trade-in-stock-img.jpeg);
      background-position: center;
      height: 300px;
  }
  .image-collection #finance-box {
      background-image: url(../../static/images/financing-stock-img.jpeg);
      background-position: center;
      height: 300px;
  }
  .image-collection #used-box {
      background-position: center;
      height: 600px;
  }
  .image-collection #new-box {
      background-position: center;
      height: 300px;
  }
  .image-collection #service-box {
      background-image: url(../../static/images/service-stock-img.jpeg);
      background-position: right;
      height: 300px;
  }
  .image-collection #parts-box {
      background-image: url(../../static/images/parts-service-stock-image.jpeg);
      background-position: center;
      height: 300px;
  }
  .image-collection #about-box {
      background-position: center;
      height: 300px;
  }

  @media (max-width: 991px) {
      .image-collection .image-overlay {
        height: 100%;
      }
      .image-collection .image-box .bottom-text {
          display: block;
          top: 65% !important;
      }
      .image-collection .image-box {
        height: 250px !important;
      }
      .image-collection .text {
        top: 30%;
      }
      .image-collection .image-box .no-wrap {
        white-space: nowrap;
      }
  }

  @media (max-width: 767px) {
    .image-collection .image-box {
        height: 175px !important;
      }
  }
</style>